<!--
<template>
  <div class="wrapper">
    <page-header :title="header.title" :add-button="header.addButton" />
    <list-header />
    <lecturer-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
    />
  </div>
</template>
-->
<script>
import { debounce } from 'lodash'

export default {
  data() {
    return {
      results: [],
      loading: true,
      service: null,
      pagination: {
        hideOnSinglePage: true,
        onChange: page => {
          this.setQueryParam('page', page)
          this.$set(this.pagination, 'current', page)
        },
        current: 1
      }
    }
  },
  created() {
    this.debouncedFetchData()
  },
  methods: {
    debouncedFetchData: debounce(function() {
      this.fetchData()
    }, 200),
    fetchData() {
      this.loading = true
      this.service
        .fetch({}, { params: this.params })
        .then(res => {
          this.results = res.data.results
          this.setPaginationData(res.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setPaginationData(responseData) {
      this.$set(this.pagination, 'pageSize', responseData.pageSize)
      this.$set(this.pagination, 'total', responseData.total)
      this.$set(this.pagination, 'current', responseData.current)
    },
    deleteInstance(
      instanceParams,
      modalOptions,
      successMessage = 'Usunięto element'
    ) {
      this.$confirm({
        title: 'Usuń element',
        maskClosable: true,
        content: 'Czy napewno chcesz usunąć ten element?',
        okText: 'Usuń',
        cancelText: 'Anuluj',
        onOk: () => {
          this.service
            .delete(instanceParams)
            .then(() => {
              this.fetchData()
              this.$notification.success({ message: successMessage })
            })
            .catch(() => {
              this.$message.error('Wystąpił bład poczas usuwania elementu')
            })
        },
        ...modalOptions
      })
    }
  },
  watch: {
    $route() {
      this.debouncedFetchData()
    }
  },
  computed: {
    params() {
      return {
        ...this.$route.query
      }
    }
  }
}
</script>
